export enum SHEET_APPEARANCE {
  FOUNDATION = 'foundation',
}
export enum SHEET_SIDE {
  LEFT = 'left',
  RIGHT = 'right',
}
